import { Anchor, Flex } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import * as React from 'react';

import s from './AuthPageBackLink.module.scss';

export type AuthPageBackLinkProps = {
  onClick: () => void;
};

const AuthPageBackLink: React.FC<AuthPageBackLinkProps> = ({ onClick }) => {
  return (
    <Anchor component="button" type="button" onClick={onClick} className={s.root}>
      <Flex align="center" gap={4}>
        <IconArrowLeft size={14} />
        <span>Назад</span>
      </Flex>
    </Anchor>
  );
};

export default AuthPageBackLink;
